module.exports = __webpack_public_path__ + "img/g-kuyaowei-nv.6f260028.jpg";